import { area } from 'd3-shape'
import { EPSILON } from 'chart-constants'
import LineAreaAdjuster from './line-area-adjuster'

class AreaAdjuster extends LineAreaAdjuster {

  constructor (options) {
    super(options)

    this.pointBasedPathGenerator = area().defined(this.defined)
                                         .x(d => d.x)
                                         .y0(d => d.y0)
                                         .y1(d => d.y1)
                                         .curve(this.curve)
  }

  /*
   * Returns a path `d` generator that creates an area path
   */
  _pathGenerator (xScale, yScale) {
     return area().x((d, i) => xScale(this.chart.xAccessor(d, i), i))
                  .y0((d, i) => yScale(Math.max(0, d._range[0]), d))
                  .y1((d, i) => yScale(d._range[1], d))
                  .defined(this.defined)
                  .curve(this.curve)
  }

  updateDrawing (selection, Curve, scalers, accessors = {}) {
    let generator = this.pathGenerator
    if (Curve) {
      scalers = scalers || {
        x: this.previous.scalers.x.center,
        y: this.previous.yScale
      }
      generator = this._pathGenerator(scalers.x, scalers.y)
                      .curve(context => new Curve(context))

      if (accessors.y0) {
        generator.y0(accessors.y0)
      }
    }

    selection.selectAll('path.area')
             .attr('d', generator)
  }

  /*
   * Inserts an area specific path binding the selection's
   * data `points` to the path
   */
  insert (selection, scalers) {
    let generator = this.pathGenerator
    if (scalers) {
      generator = this._pathGenerator(scalers.x, scalers.y)
    }

    // Area specific path
    selection.selectAll('path.area')
             .data(d => [d.points])
             .enter()
             .append('path')
             .attr('class', 'area')
             .attr('d', generator)
             .style('opacity', EPSILON) // Hide the fill of this path. Each transition for new area charts
                                        // will transition the opacity
  }

  rebind (context, points) {
    let selection = context.selection ? context.selection() : context

    selection.selectAll('path.area')
             .data([points])
    context.selectAll('path.area')
           .attr('d', this.pathGenerator) // And redraw the path with the actual data so it's properly trimmed
  }

  updatePathWithPoints (selection, points) {
    selection.selectAll('path.area')
             .attr('d', this.pointBasedPathGenerator(points)) // Update the area path w/ the new control points
  }

  transitionPaths (points, selection, merged, xScale0, xScale1) {
    selection.selectAll('path.area')
             .attr('d', this._pathGenerator(xScale0, this.previous.yScale)(points))

    // now transition
    this.transitionPathTo(points, merged, xScale1, this.yScale)
  }

  transitionPathTo (points, merged, xScale, yScale) {
    merged.selectAll('path.area')
          .attr('d', this._pathGenerator(xScale, yScale)(points))
  }

}

export default AreaAdjuster
